// src/data/assetCategories.ts

export const assetCategories = [
  'IT Assets',
  'Furniture',
  'Equipment',
  'Vehicles',
  'Supplies',
  'Software',
  'Other',
];

export const iso27001Categories: Record<string, string[]> = {
  "Human Resources": [
    "Contractors",
    "Employees",
    "External personnel (e.g., partners, customers, etc.)"
  ],
  "Infrastructure": [
    "Cloud services (IaaS, PaaS, SaaS)",
    "Data centres (On premise)",
    "Fire suppression systems",
    "HVAC systems",
    "Physical access control systems",
    "Power supply equipment (e.g., UPS)",
    "Premises"
  ],
  "IT and communication equipment": [
    "Desktop computers",
    "Desktop phones",
    "IT cabling (e.g., coaxial, fiber, ethernet, etc.)",
    "Measuring equipment",
    "Mobile devices (e.g., laptops, notebooks, tablets, smartphones, PDAs)",
    "Network equipment (e.g., firewalls, routers and switches)",
    "Printers, faxes, scanners, photocopiers and other peripherals",
    "Servers (Cloud)",
    "Servers (On Premise)",
    "Storage media",
    "Wireless LAN (includes wi-fi and/or Bluetooth, routers, adapters, access points, etc.)",
    "Wireless WAN (includes WAN assets plus wi-fi and/or Bluetooth, routers, adapters, access points, etc.)"
  ],
  "Network": [
    "LAN (includes any on-premise devices, routers, adapters, switches, etc.)",
    "VPN",
    "WAN (includes WAN devices, routers, adapters, switches, etc.)",
    "Wireless LAN (includes wi-fi and/or Bluetooth, routers, adapters, access points, etc.)",
    "Wireless WAN (includes WAN assets plus wi-fi and/or Bluetooth, routers, adapters, access points, etc.)"
  ],
  "Other document and data (in electronic and other forms)": [
    "Equipment documentation",
    "Laws, regulations, contracts and agreements",
    "Personal data (e.g., from employees or customers)",
    "Policies, procedures, plans and work instructions",
    "Proprietary data",
    "Records and logs",
    "Third-party data (not including personal data)",
    "Training documentation"
  ],
  "Software and databases": [
    "Database management systems",
    "Databases",
    "Internally developed software",
    "Operating systems",
    "Third-party custom made software",
    "Third-party off-the-shelf applications (e.g., office suite)",
    "Various software tools"
  ],
  "Third party service": [
    "Auditors, supervisory authorities",
    "Cleaning and facilities maintenance",
    "Communication services (voice, Internet, etc.)",
    "Consultants",
    "IT equipment maintenance",
    "Legal services",
    "Mail and courier services",
    "Outsourced personnel (e.g., freelancers or contractors)",
    "Power supply (electricity)",
    "Software and database maintenance",
    "Third-party services used over the Internet (e.g., SaaS)"
  ]
};

export const threatCategories = [
  'Security',
  'Operational',
  'Compliance',
  'Financial',
  'Strategic',
  'Reputational',
];

export const likelihoodOptions = [
  'Rare',
  'Unlikely',
  'Possible',
  'Likely',
  'Almost Certain',
] as const;

export const impactOptions = [
  'Insignificant',
  'Minor',
  'Moderate',
  'Serious',
  'Catastrophic',
] as const;

export const treatmentOptions = [
  'Treat the risk',
  'Avoid the risk',
  'Transfer the risk',
  'Accept the risk',
] as const;

export const controlStatusOptions = [
  'Not Started',
  'In Progress',
  'Implemented',
  'Not Applicable',
] as const;

export const reviewPeriodOptions = [
  { value: '3', label: '3 months' },
  { value: '6', label: '6 months' },
  { value: '12', label: '12 months' },
  { value: '24', label: '24 months' },
];
